import React, { Component } from 'react';
import { Button, Header, Icon, Popup, Responsive, Segment, SegmentGroup, Tab } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../util/css';
import PropertyTable from './PropertyTable';
import {
    checkFaculty,
    checkOrganizationalUnitsPrivilege, checkWritePrivilege,
    DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
    formatListForDropdownOptions,
    getTotalNumberOfPages
} from '../util/util';
import axios from 'axios';
import {
    fetchCantons,
    fetchCountries, fetchDisabledAccesses,
    fetchEntities,
    fetchMunicipalities,
    fetchOrganizationalUnits, fetchRightTypes
} from '../Lookups/util';
import {toast, ToastContainer} from 'react-toastify';
import ActiveExamTerms from '../../StudentService/ExamTerms/ActiveExamTerms';
import moment from 'moment';
import HistoryExamTerms from '../../StudentService/ExamTerms/HistoryExamTerms';
import NewProperty from './NewProperty';
import ActiveProperty from './ActiveProperty';

class Property extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        };


    }




    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })

    render() {
        const panes = [
            {
                menuItem: 'Aktivna imovina',
                render: () => (<Tab.Pane as={Responsive}>
                    <ActiveProperty />
                </Tab.Pane>)
            },
            {
                menuItem: 'Arhivirana imovina',
                render: () => (<Tab.Pane as={Responsive}>
                </Tab.Pane>)
            }
        ];

        return (
            <div>

                <Header as="h1">Nepokretna imovina</Header>

                <SegmentGroup raised>
                    <Segment raised>
                        <Header as="h3">
                            Spisak nepokretne imovine
                            <Header style={IconHeader} floated="right"> <Button
                                color="blue"
                                floated="right"
                                icon
                                labelPosition="right"
                                size="small"
                                style={FiltersOnStyle}
                                onClick={() => this.setState({ openNewProperty: true })}
                            ><Icon className="add" />
                                Dodavanje imovine
                            </Button>
                            </Header>

                        </Header>
                    </Segment>


                    <Segment>
                        <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} onTabChange={this.handleTabChange} />
                    </Segment>
<ToastContainer hideProgressBar/>
                </SegmentGroup>

            </div>
        );
    }
}

export default Property;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/Property.js